(()=>{"use strict";
if(window.DDUnifiedSearch)return;

const bound=new WeakSet();
const cache=new Map();
const rootRoute=()=>String(window.Shopify?.routes?.root||"/").replace(/\/?$/,"/");
const searchRoute=()=>rootRoute()+"search";
const suggestRoute=()=>rootRoute()+"search/suggest.json";
const locale=()=>String(document.documentElement.lang||"tr").toLowerCase().split("-")[0];
const labels=()=>{
  const all={
    tr:{products:"Ürünler",collections:"Kategoriler",all:"Tüm sonuçları gör",product:"Ürün",collection:"Kategori"},
    en:{products:"Products",collections:"Categories",all:"View all results",product:"Product",collection:"Category"},
    es:{products:"Productos",collections:"Categorías",all:"Ver todos los resultados",product:"Producto",collection:"Categoría"},
    ru:{products:"Товары",collections:"Категории",all:"Все результаты",product:"Товар",collection:"Категория"},
    ar:{products:"المنتجات",collections:"الفئات",all:"عرض كل النتائج",product:"منتج",collection:"فئة"}
  };
  all.de={products:"Produkte",collections:"Kategorien",all:"Alle Ergebnisse anzeigen",product:"Produkt",collection:"Kategorie"};
  all.fr={products:"Produits",collections:"Catégories",all:"Voir tous les résultats",product:"Produit",collection:"Catégorie"};
  return all[locale()]||all.tr;
};
const imageFor=item=>{
  const image=item?.featured_image||item?.image;
  if(typeof image==="string")return image;
  return image?.url||image?.src||"";
};
const clean=value=>String(value||"").replace(/\s+/g," ").trim();

function makeThumb(item,fallback){
  const thumb=document.createElement("span");
  thumb.className="ddus-thumb";
  const src=imageFor(item);
  if(src){
    const img=document.createElement("img");
    img.src=src;
    img.alt=item?.title||"";
    img.loading="lazy";
    thumb.appendChild(img);
  }else{
    thumb.textContent=clean(item?.title||fallback).slice(0,1).toUpperCase();
  }
  return thumb;
}
function hide(state){
  state.panel.hidden=true;
  state.panel.replaceChildren();
  state.input.setAttribute("aria-expanded","false");
  state.active=-1;
}
function focusItem(state,index){
  const items=[...state.panel.querySelectorAll("a.ddus-focusable")];
  if(!items.length)return;
  state.active=(index+items.length)%items.length;
  items.forEach((item,i)=>{
    item.classList.toggle("is-active",i===state.active);
    item.setAttribute("aria-selected",i===state.active?"true":"false");
  });
  items[state.active]?.scrollIntoView({block:"nearest"});
}
function render(state,data,term){
  const l=labels();
  const results=data?.resources?.results||{};
  const products=(results.products||[]).slice(0,4);
  const collections=(results.collections||[]).slice(0,5);
  state.panel.replaceChildren();
  state.active=-1;

  if(products.length){
    const group=document.createElement("section");
    group.className="ddus-group ddus-group--products";
    const title=document.createElement("div");
    title.className="ddus-title";
    title.textContent=l.products;
    const list=document.createElement("div");
    list.className="ddus-products";
    products.forEach(item=>{
      const link=document.createElement("a");
      link.className="ddus-product ddus-focusable";
      link.href=item.url||searchRoute();
      link.setAttribute("role","option");
      link.setAttribute("aria-selected","false");
      link.appendChild(makeThumb(item,l.product));
      const copy=document.createElement("span");
      copy.className="ddus-copy";
      const name=document.createElement("strong");
      name.className="ddus-name";
      name.textContent=item.title||"";
      const meta=document.createElement("small");
      meta.className="ddus-meta";
      meta.textContent=item.vendor||item.type||item.product_type||l.product;
      copy.append(name,meta);
      const arrow=document.createElement("span");
      arrow.className="ddus-arrow";
      arrow.setAttribute("aria-hidden","true");
      arrow.textContent="→";
      link.append(copy,arrow);
      list.appendChild(link);
    });
    group.append(title,list);
    state.panel.appendChild(group);
  }

  if(collections.length){
    const group=document.createElement("section");
    group.className="ddus-group ddus-group--collections";
    const title=document.createElement("div");
    title.className="ddus-title";
    title.textContent=l.collections;
    const chips=document.createElement("div");
    chips.className="ddus-chips";
    collections.forEach(item=>{
      const link=document.createElement("a");
      link.className="ddus-chip ddus-focusable";
      link.href=item.url||searchRoute();
      link.setAttribute("role","option");
      link.setAttribute("aria-selected","false");
      link.textContent=item.title||l.collection;
      chips.appendChild(link);
    });
    group.append(title,chips);
    state.panel.appendChild(group);
  }

  if(products.length||collections.length){
    const more=document.createElement("a");
    more.className="ddus-all ddus-focusable";
    more.href=searchRoute()+"?q="+encodeURIComponent(term);
    more.setAttribute("role","option");
    more.setAttribute("aria-selected","false");
    more.innerHTML="<span>"+l.all+"</span><span aria-hidden='true'>→</span>";
    state.panel.appendChild(more);
    state.panel.hidden=false;
    state.input.setAttribute("aria-expanded","true");
  }else{
    hide(state);
  }
}
async function run(state){
  const term=clean(state.input.value);
  if(term.length<2){
    state.controller?.abort();
    hide(state);
    return;
  }
  const key=locale()+"|"+term.toLocaleLowerCase(locale()==="tr"?"tr-TR":undefined);
  if(cache.has(key)){
    render(state,cache.get(key),term);
    return;
  }
  state.controller?.abort();
  state.controller=new AbortController();
  const params=new URLSearchParams();
  params.set("q",term);
  params.set("resources[type]","product,collection");
  params.set("resources[limit]","6");
  params.set("resources[limit_scope]","each");
  params.set("resources[options][unavailable_products]","hide");
  try{
    const response=await fetch(suggestRoute()+"?"+params.toString(),{
      signal:state.controller.signal,
      headers:{"Accept":"application/json"}
    });
    if(!response.ok)throw new Error(String(response.status));
    const data=await response.json();
    cache.set(key,data);
    if(clean(state.input.value)!==term)return;
    render(state,data,term);
  }catch(error){
    if(error?.name==="AbortError")return;
    hide(state);
  }
}
function bind(form,options={}){
  if(!form||bound.has(form))return;
  const input=form.querySelector('input[type="search"]');
  if(!input)return;
  bound.add(form);
  const kind=options.kind||"desktop";
  form.dataset.ddUnifiedSearch="1";
  input.name=input.name||"q";
  if(!form.getAttribute("action"))form.action=searchRoute();
  if(!form.getAttribute("method"))form.method="get";
  input.autocomplete="off";
  input.setAttribute("aria-autocomplete","list");
  input.setAttribute("aria-expanded","false");

  const panel=document.createElement("div");
  panel.className="ddus-results ddus-results--"+kind;
  panel.dataset.ddUnifiedResults="";
  panel.hidden=true;
  panel.setAttribute("role","listbox");
  panel.setAttribute("aria-live","polite");
  form.insertAdjacentElement("afterend",panel);

  const state={form,input,panel,kind,timer:0,controller:null,active:-1};
  input.addEventListener("input",()=>{
    clearTimeout(state.timer);
    state.active=-1;
    state.timer=setTimeout(()=>run(state),140);
  });
  input.addEventListener("search",()=>run(state));
  input.addEventListener("focus",()=>{if(clean(input.value).length>=2)run(state)});
  input.addEventListener("keydown",event=>{
    if(event.key==="ArrowDown"||event.key==="ArrowUp"){
      const items=[...panel.querySelectorAll("a.ddus-focusable")];
      if(!items.length)return;
      event.preventDefault();
      const delta=event.key==="ArrowDown"?1:-1;
      focusItem(state,state.active<0?(delta>0?0:items.length-1):state.active+delta);
      return;
    }
    if(event.key==="Enter"&&state.active>=0){
      const item=panel.querySelectorAll("a.ddus-focusable")[state.active];
      if(item){event.preventDefault();item.click()}
      return;
    }
    if(event.key==="Escape"&&!panel.hidden){
      event.preventDefault();
      hide(state);
    }
  });
  document.addEventListener("pointerdown",event=>{
    if(event.target instanceof Node&&!form.contains(event.target)&&!panel.contains(event.target))hide(state);
  },{passive:true});
  const host=form.closest("[data-ddh4-search]");
  if(host)new MutationObserver(()=>{if(host.hidden)hide(state)}).observe(host,{attributes:true,attributeFilter:["hidden"]});
  if(clean(input.value).length>=2)run(state);
}
function autoBind(scope=document){
  scope.querySelectorAll?.("[data-ddh4-search] form").forEach(form=>bind(form,{kind:"desktop"}));
}
window.DDUnifiedSearch={bind,autoBind};
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",()=>autoBind(document),{once:true});else autoBind(document);
document.addEventListener("shopify:section:load",event=>autoBind(event.target));
})();